import { PolymerElement, html } from 'polymer';

/**
 * @customElement
 * @polymer
 * @appliesMixin HIP.BehaviorElement
 */
class PendingElement extends HIP.BehaviorElement(PolymerElement) {
  static get is() {
    return 'hi-pending';
  }

  static get template() {
    return html` <style is="custom-style" include="hi-theme"></style>
      <style>
        :host {
          position: relative;
          display: block;
          min-height: var(--hi-size--enormous-xxx);
        }

        :host([busy]) {
          -moz-user-focus: ignore !important;
          pointer-events: none !important;
          user-select: none !important;
          cursor: default !important;
        }

        #dimmer {
          background-color: var(--hi-color--transparent);
        }

        :host([busy]) #dimmer {
          top: 0;
          background-color: var(--hi-color--white);
        }

        #dimmer,
        #banner {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          opacity: 0.8;
          display: block;
        }

        #banner {
          display: flex;
          align-items: center;
          border-top: var(--hi-size--pixel-1) solid var(--hi-color--theme-30);
          height: var(--hi-size--enormous-x);
          background-color: var(--hi-color--white);
        }

        #dimmer[hidden],
        #banner[hidden] {
          display: none;
        }

        #label-busy {
          color: var(--hi-color--theme-30);
          margin-right: var(--hi-size--medium);
          margin-left: auto;
        }

        hi-indicator {
          margin-left: var(--hi-size--medium);
        }
      </style>
      <div mixin="text-natural">
        <slot></slot>
      </div>

      <div id="dimmer" hidden$="[[ !busy ]]"></div>
      <div id="banner" hidden$="[[ !busy ]]">
        <hi-indicator theme="[[ theme ]]"></hi-indicator>
        <label id="label-busy" text-size="medium"> [[ labelBusy ]] </label>
      </div>`;
  }

  static get properties() {
    return {
      busy: {
        type: Boolean,
        observer: '__onBusyChanged',
        reflectToAttribute: true,
        notify: true
      },
      labelBusy: {
        type: String,
        value: 'Waiting...'
      }
    };
  }

  static get autoBinding() {
    return {
      signal: 'busy-changed',
      slot: 'busy'
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'status');
  }

  __onBusyChanged(busyState) {
    this.setAttribute('aria-busy', busyState + '');
  }

  /**
   * @returns {string} the busy label if the spinner is on
   */
  toString() {
    return this.busy ? this.labelBusy : '';
  }
}

HIP.factory.element(PendingElement);
